// src/components/RoleSelection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import './RoleSelection.css';

export default function RoleSelection() {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      navigate('/signin');
      return;
    }
    navigate(route);
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Failed to sign out. Please try again.');
    }
  };

  return (
    <div className="role-selection-container">
      <div className="role-selection-content">
        <div className="role-buttons">
          <button
            className="role-button admin-button"
            onClick={() => handleNavigation('/admin')}
          >
            <div className="button-icon">🔧</div>
            <h3>Admin</h3>
          </button>

          <button
            className="role-button creator-button"
            onClick={() => handleNavigation('/creator-dashboard')}
          >
            <div className="button-icon">✨</div>
            <h3>Creator</h3>
          </button>
        </div>

        <button
          className="logout-button"
          onClick={handleSignOut}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
